import { createSelector } from 'reselect';

const getState = (state) => state.directOrderRecurring.data.repeatedFrom;

const getRepeatedFrom = createSelector(
  getState,
  (repeatedFrom) => repeatedFrom
);

export default {
  getRepeatedFrom,
};
